import { Outlet } from "react-router-dom";
import  Navbar  from "./Navbar"; 

  
  export const SharedLayout = () => {
    return (
      <div className="shared-layout">
        <Navbar />
        <main className="main-content">
          <Outlet /> {/* This renders the matched child route */}
        </main>
      </div>
    );
  };

  export default SharedLayout; 